import {
  IonBadge,
  IonButton,
  IonCard,
  IonContent,
  IonList,
  IonPage,
  IonSpinner,
  useIonModal
} from "@ionic/react";
import { useLobbiesStore } from "../stores/lobbies.store";
import { useUsersStore } from "../stores/users.store";
import Header from "../components/Header";
import ChallengeCard from "../components/ChallengeCard";
import { ReactComponent as LobbiesIcon } from "../assets/graphics/workspaces.svg";
import HostLobby from "./HostLobby";
import HelpButton from "../components/HelpButton";

const Lobbies = () => {
  const user = useUsersStore(state => state.user);
  const [userLobbies, loading] = useLobbiesStore(state => [
    state.lobbies.filter(lobby =>
      user?.userId ? lobby.participants.includes(user.userId) : []
    ),
    state.loading
  ]);
  const [presentHostLobby, dismissHostLobby] = useIonModal(HostLobby, {
    onDismiss: async (confirm: boolean) => {
      dismissHostLobby();
    }
  });

  const activeLobbies = userLobbies.filter(
    lobby =>
      lobby?.started && !lobby?.ended && !(lobby?.quest || lobby?.challenge)
  );
  const pastLobbies = userLobbies.filter(
    lobby => lobby?.started && lobby?.ended
  );
  const upcomingLobbies = userLobbies.filter(
    lobby =>
      !lobby?.name?.startsWith("CHALLENGE") &&
      !lobby?.started &&
      !lobby?.ended &&
      !(lobby?.quest || lobby?.challenge)
  );

  return (
    <IonPage>
      <Header title="Lobbies" backHref="/lobbies" />
      <IonContent fullscreen scrollY={false}>
        <div className="bg-primary-90 h-full flex justify-center">
          <div className="max-w-xl">
            <div className="p-2 shadow-xl">
              <ChallengeCard />
            </div>
            <div className="flex flex-col h-4/6">
              <div className="grow">
                <div className="flex items-center justify-between">
                  <div className="text-3xl font-bold px-4 py-2">Lobbies</div>
                  <HelpButton id="lobbies" />
                </div>
                <div className="px-4 text-primary-10 text-lg">
                  Compete against other bots to earn QUO and a global ranking.
                </div>
                <IonCard
                  className="my-4 bg-primary-80 text-white"
                  button
                  // disabled={activeLobbies?.length === 0}
                  routerLink={`/lobbyList/active`}
                >
                  <div className="px-4 py-2 flex justify-between">
                    <div className="text-lg flex items-center justify-start w-full">
                      <LobbiesIcon className="p-1 active-fill bg-primary-90" />
                      <div className="font-semibold px-2">Active</div>
                    </div>
                    <IonBadge
                      slot="start"
                      className="text-base px-2 rounded-lg bg-primary-90 text-primary-30"
                    >
                      {loading ? (
                        <div className="ion-text-center">
                          <IonSpinner />
                        </div>
                      ) : (
                        activeLobbies?.length || 0
                      )}
                    </IonBadge>
                  </div>
                  <div className="px-4 pb-2">
                    Lobbies that are currently active
                  </div>
                </IonCard>
                <IonCard
                  className="my-4 bg-primary-80 text-white"
                  button
                  routerLink={`/lobbyList/upcoming`}
                >
                  <div className="px-4 py-2 flex justify-between">
                    <div className="text-lg flex items-center justify-start w-full">
                      <LobbiesIcon className="p-1 upcoming-fill bg-primary-90" />
                      <div className="font-semibold px-2">Upcoming</div>
                    </div>
                    <IonBadge
                      slot="start"
                      className="text-base px-2 rounded-lg bg-primary-90 text-primary-30"
                    >
                      {loading ? (
                        <div className="ion-text-center">
                          <IonSpinner />
                        </div>
                      ) : (
                        upcomingLobbies?.length || 0
                      )}
                    </IonBadge>
                  </div>
                  <div className="px-4 pb-2">
                    Lobbies that you are scheduled to trade in
                  </div>
                </IonCard>
                <IonCard
                  className="my-4 bg-primary-80 text-white"
                  button
                  // disabled={pastLobbies?.length === 0}
                  routerLink={`/lobbyList/past`}
                >
                  <div className="px-4 py-2 flex justify-between">
                    <div className="text-lg flex items-center justify-start w-full">
                      <LobbiesIcon className="p-1 past-fill bg-primary-90" />
                      <div className="font-semibold px-2">Past</div>
                    </div>
                    <IonBadge
                      slot="start"
                      className="text-base px-2 rounded-lg bg-primary-90 text-primary-30"
                    >
                      {loading ? (
                        <div className="ion-text-center">
                          <IonSpinner />
                        </div>
                      ) : (
                        pastLobbies?.length || 0
                      )}
                    </IonBadge>
                  </div>
                  <div className="px-4 pb-2">
                    Lobbies that you have traded in
                  </div>
                </IonCard>
              </div>
              <IonList lines="none" className="pb-2 bg-transparent">
                <div className="ion-text-center">
                  <IonButton
                    color="primary"
                    onClick={() => presentHostLobby()}
                    className="h-12 text-base rounded-xl w-40 mx-2"
                  >
                    Host a Lobby
                  </IonButton>
                  <IonButton
                    color="primary"
                    className="h-12 text-base rounded-xl w-40 mx-2 my-2"
                    routerLink="/lobbyList/join"
                  >
                    Join a Lobby
                  </IonButton>
                </div>
              </IonList>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Lobbies;
